import { homeSubLinkNames, TextStorage } from "./multilang-text-storage"
import { MenuOptionId } from "./constants"

export const getMenuOptions = (
  ids: MenuOptionId[],
  pathName: string,
  ts?: TextStorage,
) =>
  ids.map((id) => {
    const isSubLink = homeSubLinkNames.has(id)
    const linksTo = isSubLink ? `/#${id}` : `/${id}`
    return {
      id: id,
      displayText: ts?.menuOptions?.[id] ?? id,
      linksTo: linksTo,
      isActive: pathName === `/${id}`,
    }
  })
